import React from "react";
import ChatComponent from "./components/ChatComponent";

function App() {
  return (
    <div>
      <ChatComponent />
    </div>
  );
}

export default App;
